<div class="page-header">
  <div class="page-title" data-clarity-unmask="true">Wersje aplikacji</div>
  <div class="page-subtitle">wymuszona i zalecana aktualizacja aplikacji mobilnych</div>
</div>

<div class="app-versions">
  <div class="info">
    <p>
      <strong>Minimalna wersja</strong> — starsze wersje aplikacji pokażą pełnoekranowy komunikat „Wymagana
      aktualizacja” z przeprosinami i przyciskiem do sklepu; nie da się go zamknąć.
    </p>
    <p>
      <strong>Zalecana wersja</strong> — starsze wersje zobaczą zamykane okienko „Dostępna nowa wersja”
      (po „Później” pokaże się znowu dopiero po podniesieniu tej wersji).
    </p>
    <p>
      Wpisuj nazwę wersji ze sklepu (Android np. 1.23, iOS np. 1.12). Minimalną wersję podnoś dopiero, gdy nowa
      wersja jest dostępna dla wszystkich — przy stopniowym wdrażaniu lub w trakcie recenzji Apple część
      użytkowników nie mogłaby się zaktualizować. Puste pole = brak wymagań.
    </p>
  </div>

  @if (errorMessage) {
    <div class="banner error">
      <i class="pi pi-exclamation-triangle"></i>
      <span>{{ errorMessage }}</span>
    </div>
  }

  @if (successMessage) {
    <div class="banner success">
      <i class="pi pi-check-circle"></i>
      <span>{{ successMessage }}</span>
    </div>
  }

  @if (loading && !platforms.length) {
    <div class="flex justify-content-center py-5">
      <p-progressSpinner styleClass="w-3rem h-3rem" ariaLabel="loading" />
    </div>
  }

  @if (platforms.length) {
    <div class="platforms">
      @for (platform of platforms; track platform.key) {
        <div class="platform-card">
          <div class="platform-title">
            <i [class]="platform.icon"></i>
            <span>{{ platform.label }}</span>
          </div>

          <label [for]="platform.key + '-minimum'" class="field-label">Minimalna wersja (blokada)</label>
          <input
            [id]="platform.key + '-minimum'"
            pInputText
            [(ngModel)]="platform.minimumVersion"
            [placeholder]="'np. ' + platform.example"
            [disabled]="saving"
          />

          <label [for]="platform.key + '-recommended'" class="field-label">Zalecana wersja (przypomnienie)</label>
          <input
            [id]="platform.key + '-recommended'"
            pInputText
            [(ngModel)]="platform.recommendedVersion"
            [placeholder]="'np. ' + platform.example"
            [disabled]="saving"
          />

          <label [for]="platform.key + '-store'" class="field-label">Link do sklepu</label>
          <input [id]="platform.key + '-store'" pInputText [(ngModel)]="platform.storeUrl" [disabled]="saving" />
        </div>
      }
    </div>

    <div class="actions">
      <p-button label="Zapisz" icon="pi pi-save" [loading]="saving" (onClick)="save()" data-clarity-unmask="true" />
      <p-button label="Odśwież" icon="pi pi-refresh" [outlined]="true" [disabled]="saving" (onClick)="load()" data-clarity-unmask="true" />
      @if (saved?.updatedAt) {
        <span class="muted">
          Ostatnia zmiana: {{ saved?.updatedAt | date: 'yyyy-MM-dd HH:mm' }}
          @if (saved?.updatedBy) {
            , {{ saved?.updatedBy }}
          }
        </span>
      }
    </div>
  }
</div>
